import { Urls } from '@2meters/types'
import { functions } from 'api/Firebase/firebase-init'
import { httpsCallable } from 'firebase/functions'

export function markChatMessagesRead(request: { placeId: string; appointmentId: string }) {
  const fn = httpsCallable(functions, `${Urls.visitor.prefix}${Urls.visitor.markChatMessagesRead}`)
  return fn(request)
}
